<template>
  <div>
    <toolbar-view title="Шаблоны сообщений">
      <template v-slot:barActions>
        <v-btn icon @click="view = view===null ? 'search' : null;searchText=null">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-btn icon @click="view = view===null ? 'create' : null">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn icon :loading="stateSync.loading" @click="refresh()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>
    </toolbar-view>
    <v-text-field v-show="view==='search'" v-model="searchText" class="mx-4 pt-2 mb-4"
                  clearable dense hide-details label="Введите текст для поиска..." outlined/>
    <v-sheet :max-height="height-48-(view==='search' ? 64 : 0)" class="overflow-y-auto">
      <progress-page v-if="state.loading && state.data.count===0"/>
      <div v-show="view==='create'" class="px-4 pt-2">
        <v-textarea
            v-model="createText"
            :disabled="!!createTemplateExternal"
            auto-grow
            class="mb-4"
            dense
            hide-details
            label="Текст"
            outlined
            rows="1"
        />
        <dialog-message-template-external-autocomplete-single
            ref="externalAutocomplete"
            :select.sync="createTemplateExternal"
        />
        <v-row no-gutters>
          <v-col>
            <v-btn class="mr-2" depressed small @click="cancelCreate()">Отмена</v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn :loading="stateCreate.loadingUpdate" depressed small @click="create()">Создать</v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-if="view==='edit' && editTemplate" class="px-4 pt-2">
        <v-textarea
            v-model="editText"
            :disabled="!!editTemplateExternal"
            auto-grow
            class="mb-4"
            dense
            hide-details
            label="Текст"
            outlined
            rows="1"
        />
        <dialog-message-template-external-autocomplete-single
            :select.sync="editTemplateExternal"
        />
        <div v-if="editTemplate.buttons && editTemplate.buttons.length>0" class="mb-2 caption">Кнопки</div>
        <div v-if="!editTemplate.buttons || editTemplate.buttons.length===0" class="caption mb-4">
          Нет кнопок
        </div>
        <div
            v-for="button in (editTemplate.buttons || []).filter(Boolean)"
            :key="button.id"
            class="mb-4"
        >
          <v-select
              v-model="button.type"
              :items="buttonTypes"
              :loading="!!buttonTypeLoading[button.id]"
              clearable
              dense
              hide-details
              item-text="name"
              item-value="id"
              :label="button.text"
              outlined
              @change="updateButtonType(button)"
          />
        </div>
        <v-row no-gutters class="mb-3">
          <v-col>
            <v-btn class="mr-2" depressed small @click="cancelEdit()">Отмена</v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn :loading="stateEdit.loadingUpdate" depressed small @click="saveEdit()">Сохранить</v-btn>
          </v-col>
        </v-row>
      </div>
      <v-list v-show="view===null || view==='search'" class="pa-0" dense>
        <div v-if="state.success && templates().length===0" class="text-center">
          <alert>Не найдено</alert>
        </div>
        <v-list-item
            v-for="(item, i) in templates()"
            :key="i"
            class="pa-0" @click="selectTemplateSelect(item)"
        >
          <v-row no-gutters>
            <v-col class="py-2 px-4 body-2" cols="auto" v-html="$tools.nl2br(item.text || '')"></v-col>
            <v-col v-if="item.templateExternal" class="caption px-4 pb-1 d-flex align-center" cols="12">
              <v-avatar
                  v-if="providerById(item.templateExternal.provider)"
                  :color="providerById(item.templateExternal.provider).iconBgColor"
                  size="16"
                  class="mr-1"
              >
                <v-icon color="white" size="10">{{ providerById(item.templateExternal.provider).icon }}</v-icon>
              </v-avatar>
              {{ providerLabel(item.templateExternal.provider) }}
              <template v-if="!$tools.isEmpty(item.templateExternal.sid)"> · {{ item.templateExternal.sid }}</template>
            </v-col>
            <v-col v-if="item.buttons && item.buttons.filter(Boolean).length>0" class="caption px-4 pb-1" cols="12">
              Действия:
              <span v-for="(b, bi) in item.buttons.filter(Boolean)" :key="b.id">
                <template v-if="bi > 0">, </template>
                {{ b.text }}<template v-if="buttonTypeLabel(b.type)"> ({{ buttonTypeLabel(b.type) }})</template>
              </span>
            </v-col>
            <v-col class="caption px-3 pb-3" cols="12">
              <v-btn
                  class="mr-2"
                  depressed
                  small
                  @click.stop="openEdit(item)"
              >Изменить
              </v-btn>
              <btn-small-accept btn-class="mr-2" name="Удалить" @accept="remove(item.id)"/>
              <v-btn class="mr-2" depressed small @click.stop="sort(item.id, true)">
                <v-icon color="grey" small>mdi-chevron-up-circle</v-icon>
              </v-btn>
              <v-btn depressed small @click.stop="sort(item.id, false)">
                <v-icon color="grey" small>mdi-chevron-down-circle</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-divider/>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
      <dialog-view
          :open="selectTemplateOpen"
          title="Введите значение текстовых тегов"
          content-full-size
          width="900"
          :loading="selectTemplateState.loading"
          @cancel="selectTemplateOpen=false"
      >
        <template v-slot:content>
          <div v-if="selectTemplate!==null">
            <v-expansion-panels v-model="opens" accordion multiple>
              <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-medium px-4">Пример</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="$tools.nl2br(selectTemplate.textExample)" class="mx-n2"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-medium px-4">Результат</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="$tools.nl2br(selectTemplate.textResult)" class="mx-n2"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-divider/>
            <div class="ma-4">
              <div class="caption mb-2">Значения</div>
              <v-row class="rowSmall">
                <v-col
                    v-for="(v, k) in selectTemplate.textTags"
                    :key="k"
                    cols="4"
                >
                  <v-text-field
                      :label="v.alias"
                      :hint="$tools.isEmpty(v.example) ? null : 'Пример:'+v.example"
                      v-model="v.value"
                      @keyup="selectTemplateSelectUpdate()"
                      dense outlined hide-details="auto"
                  >
                    <template v-slot:append>
                      <tooltip-view v-if="v.auto">
                        <template v-slot:action>
                          <v-icon>mdi-refresh-auto</v-icon>
                        </template>
                        <template v-slot:content>
                          <div class="caption mb-2">Для это текстового тега включена авто генерация значения</div>
                        </template>
                      </tooltip-view>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <v-row no-gutters>
            <v-col></v-col>
            <v-col cols="auto">
              <v-btn @click="selectTemplateAction()" text color="primary">
                Вставить
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </dialog-view>
    </v-sheet>
  </div>
</template>

<script>
import BtnSmallAccept from "../../../../componentsV2/base/BtnSmallAccept.vue";
import Stater from "@/plugins/stater";
import axios from "axios";
import ToolbarView from "@/components/ToolbarView.vue";
import {
  Entity_DialogMessageTemplate,
  Entity_DialogMessageTemplateButton,
  Entity_DialogMessageTemplateExternal,
} from "../../../../../EntityStoreCacheService";
import Alert from "@/componentsV2/base/Alert.vue";
import ProgressPage from "@/components/ProgressPage.vue";
import DialogMessageTemplateExternalAutocompleteSingle
  from "@/componentsV2/custom/DialogMessageTemplateExternalAutocompleteSingle.vue";
import DialogView from "@/components/DialogView.vue";
import TooltipView from "@/components/TooltipView.vue";

export default {
  components: {
    TooltipView,
    DialogView,
    DialogMessageTemplateExternalAutocompleteSingle,
    ProgressPage,
    Alert,
    ToolbarView,
    BtnSmallAccept,
  },
  props: ['items', 'chat', 'height'],
  data: () => ({
    state: new Stater({items: [], count: 0}),
    view: null,
    searchText: null,
    stateCreate: new Stater(),
    stateEdit: new Stater(),
    stateSync: new Stater(),
    createText: null,
    createTemplateExternal: null,
    providers: [],
    buttonTypes: [],
    editTemplate: null,
    editText: null,
    editTemplateExternal: null,
    buttonTypeLoading: {},
    selectTemplate: null,
    selectTemplateItem: null,
    selectTemplateOpen: false,
    selectTemplateState: new Stater(),
    opens: [1],
  }),
  computed: {
    providersMap() {
      const map = {};
      this.providers.forEach(p => {
        map[p.id] = p;
      });
      return map;
    },
    buttonTypesMap() {
      const map = {};
      this.buttonTypes.forEach(t => {
        map[t.id] = t;
      });
      return map;
    },
  },
  watch: {
    chat(newChat, oldChat) {
      if (newChat?.id !== oldChat?.id)
        this.load();
    },
    createTemplateExternal(v) {
      if (v && !this.$tools.isEmpty(v.text))
        this.createText = v.text;
    },
    editTemplateExternal(v) {
      if (v && !this.$tools.isEmpty(v.text))
        this.editText = v.text;
    },
  },
  mounted() {
    this.loadProviders();
    this.loadButtonTypes();
    this.load();
  },
  methods: {
    providerById(id) {
      return this.providersMap[id] || null;
    },
    providerLabel(provider) {
      return this.providersMap[provider]?.name || provider;
    },
    buttonTypeLabel(type) {
      return this.buttonTypesMap[type]?.name || null;
    },
    loadProviders() {
      axios.get('/napi/dialog/provider/').then(r => {
        this.providers = r.data;
      });
    },
    loadButtonTypes() {
      axios.get('/napi/dialog/button/type/').then(r => {
        this.buttonTypes = r.data || [];
      }).catch(() => {
        this.buttonTypes = [];
      });
    },
    load() {
      new Entity_DialogMessageTemplate()
          .selects(Entity_DialogMessageTemplate.id)
          .selects(Entity_DialogMessageTemplate.sort)
          .selects(Entity_DialogMessageTemplate.text)
          .selects([Entity_DialogMessageTemplate.templateExternal, Entity_DialogMessageTemplateExternal.id].join('.'))
          .selects([Entity_DialogMessageTemplate.templateExternal, Entity_DialogMessageTemplateExternal.provider].join('.'))
          .selects([Entity_DialogMessageTemplate.templateExternal, Entity_DialogMessageTemplateExternal.sid].join('.'))
          .selects([Entity_DialogMessageTemplate.templateExternal, Entity_DialogMessageTemplateExternal.text].join('.'))
          .selects([Entity_DialogMessageTemplate.buttons, Entity_DialogMessageTemplateButton.id].join('.'))
          .selects([Entity_DialogMessageTemplate.buttons, Entity_DialogMessageTemplateButton.text].join('.'))
          .selects([Entity_DialogMessageTemplate.buttons, Entity_DialogMessageTemplateButton.type].join('.'))
          .selects([Entity_DialogMessageTemplate.buttons, Entity_DialogMessageTemplateButton.sort].join('.'))
          .order(Entity_DialogMessageTemplate.sort, true)
          .filterAnd([Entity_DialogMessageTemplate.entity, Entity_DialogMessageTemplate.status].join('.') + '=?', 'active')
          .addStateCallback((v) => this.state.setRequestBuilderState(v, false))
          .addStateCallback((v) => {
            if (v.success)
              this.$emit('update:items', v.items);
          })
          .request();
    },
    chatClientUserId() {
      if (this.chat === null)
        return null;
      const clientUser = (this.chat.dialogUsers || [])
          .find(v => v.provider !== 'internal' && v.user?.id);
      return clientUser?.user?.id || null;
    },
    templates() {
      let arr = this.state.data.items || [];
      if (!this.$tools.isEmpty(this.searchText))
        arr = arr.filter(v => (v.text || '').toLowerCase().includes(this.searchText.toLowerCase()))
      return arr;
    },
    create() {
      this.stateCreate.stateLoadingUpdate();
      axios.post('/napi/dialog/messageTemplate/', {
        text: this.createText,
        templateExternalId: this.createTemplateExternal?.id ?? null,
      }).then(() => {
        this.stateCreate.stateSuccess();
        this.cancelCreate();
        this.load();
      }).catch(() => {
        this.stateCreate.stateError();
      });
    },
    cancelCreate() {
      this.view = null;
      this.createText = null;
      this.createTemplateExternal = null;
    },
    openEdit(item) {
      this.editTemplate = {
        ...item,
        buttons: (item.buttons || []).filter(Boolean).map(b => ({...b})),
      };
      this.editText = item.text;
      this.editTemplateExternal = item.templateExternal
          ? {...item.templateExternal}
          : null;
      this.view = 'edit';
    },
    cancelEdit() {
      this.view = null;
      this.editTemplate = null;
      this.editText = null;
      this.editTemplateExternal = null;
      this.buttonTypeLoading = {};
    },
    saveEdit() {
      if (!this.editTemplate)
        return;
      this.stateEdit.stateLoadingUpdate();
      axios.put('/napi/dialog/messageTemplate/' + this.editTemplate.id + '/', {
        text: this.editText,
        templateExternalId: this.editTemplateExternal?.id ?? null,
      }).then(() => {
        this.stateEdit.stateSuccess();
        this.cancelEdit();
        this.load();
      }).catch(() => {
        this.stateEdit.stateError();
      });
    },
    updateButtonType(button) {
      if (!button || !button.id)
        return;
      this.$set(this.buttonTypeLoading, button.id, true);
      axios.put('/napi/dialog/messageTemplate/button/' + button.id + '/', {
        type: button.type || null,
      }).then(() => {
        this.$set(this.buttonTypeLoading, button.id, false);
        this.load();
      }).catch(() => {
        this.$set(this.buttonTypeLoading, button.id, false);
      });
    },
    remove(id) {
      axios.put('/napi/dialog/messageTemplate/' + id + '/', {
        status: 'deleted'
      }).then(() => {
        this.load();
      });
    },
    sort(id, isUp) {
      this.stateCreate.stateLoadingUpdate();
      axios.put('/napi/dialog/messageTemplate/' + id + '/', {
        sortDirection: isUp ? 'up' : 'down',
      }).then(() => {
        this.stateCreate.stateSuccess();
        this.load();
      });
    },
    selectTemplateSelect(item) {
      this.selectTemplateItem = item;
      this.selectTemplateState.stateLoading();
      axios.post('/napi/dialog/messageTemplate/' + item.id + '/preview/', {
        userId: this.chatClientUserId(),
        textTags: [],
      }).then(r => {
        this.selectTemplate = r.data;
        const hasEmpty = (this.selectTemplate.textTags || [])
            .some(t => this.$tools.isEmpty(t.value));
        if (!hasEmpty) {
          this.selectTemplateAction();
        } else {
          this.selectTemplateOpen = true;
        }
        this.selectTemplateState.stateSuccess();
      }).catch(() => {
        this.selectTemplateState.stateError();
      });
    },
    selectTemplateSelectUpdate() {
      if (!this.selectTemplate)
        return;
      this.selectTemplateState.stateLoading();
      this.$tools.debounce(() => {
        axios.post('/napi/dialog/messageTemplate/' + this.selectTemplate.id + '/preview/', {
          userId: this.chatClientUserId(),
          textTags: this.selectTemplate.textTags,
        }).then(r => {
          this.selectTemplate = r.data;
          this.selectTemplateState.stateSuccess();
        }).catch(() => {
          this.selectTemplateState.stateError();
        });
      }, 500, 'dialogUpdateSelectTemplateAction');
    },
    selectTemplateAction() {
      if (!this.selectTemplate)
        return;
      this.selectTemplateOpen = false;
      this.$emit('select', {
        id: this.selectTemplate.id,
        text: this.selectTemplate.text,
        textResult: this.selectTemplate.textResult,
        textTags: this.selectTemplate.textTags || [],
        templateExternal: this.selectTemplateItem?.templateExternal || null,
        buttons: this.selectTemplateItem?.buttons || [],
      });
      this.selectTemplate = null;
      this.selectTemplateItem = null;
    },
    refresh() {
      this.stateSync.stateLoading();
      axios.get('/napi/dialog/messageTemplate/sync/').then(() => {
        this.stateSync.stateSuccess();
        this.$refs.externalAutocomplete?.reload();
        this.state = new Stater({items: [], count: 0});
        this.state.stateLoading()
        this.load();
      }).catch(() => {
        this.stateSync.stateError();
      });
    }
  }
}
</script>
